import { useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

import ImagePolicy13 from "../../../assets/policies/policy_guide_13.png";
import ImagePolicy14 from "../../../assets/policies/policy_guide_14.png";
import { useTranslation } from "react-i18next";

const PayWithBankCard = () => {
  const { t } = useTranslation();
  const [stage, setStage] = useState(0);

  const handleOnChangeStage = (stage: number) => {
    setStage(stage);
  };

  return (
    <div className="px-8 py-12 w-[90%] max-w-[100%] rounded-xl bg-white flex drop-shadow-2xl">
      <div className="w-[40%] mr-6 flex flex-col justify-center items-center">
        <PhotoProvider>
          <PhotoView src={ImagePolicy13}>
            <img
              src={ImagePolicy13}
              alt="VN PAY-QR"
              className="scale-75 cursor-pointer"
            />
          </PhotoView>
        </PhotoProvider>
        <PhotoProvider>
          <PhotoView src={ImagePolicy14}>
            <img
              src={ImagePolicy14}
              alt="VN PAY-QR"
              className="scale-75 cursor-pointer"
            />
          </PhotoView>
        </PhotoProvider>
      </div>
      <div className="grow-1 flex flex-col justify-evenly items-start">
        <div className="mb-4 flex items-center">
          <span
            className={`w-[40px] mr-10 flex justify-center items-center cursor-pointer ${
              stage === 0
                ? "w-8 h-10 rounded-full text-white bg-[#0f2471] shadow-xl"
                : "w-8 h-10 border-2 border-[#0f2471] text-[#0f2471] rounded-full"
            }`}
            onClick={() => {
              handleOnChangeStage(0);
            }}
          >
            {1}
          </span>
          <div
            className={`w-[220px] lg:w-[800px] flex flex-col justify-center ${
              stage === 0 ? "text-xl font-bold text-[#0f2471]" : ""
            }`}
          >
            <span className={`${stage === 0 ? "mb-4" : ""}`}>
              {t("policy.payment.method2_content.step1.title")}
            </span>

            {stage === 0 && (
              <span className="whitespace-normal text-justify text-base font-bold text-black">
                {t("policy.payment.method2_content.step1.content")}
              </span>
            )}
          </div>
        </div>
        <div className="mb-4 flex items-center">
          <span
            className={`w-[40px] mr-10 flex justify-center items-center cursor-pointer ${
              stage === 1
                ? "w-8 h-10 rounded-full text-white bg-[#0f2471] shadow-xl"
                : "w-8 h-10 border-2 border-[#0f2471] text-[#0f2471] rounded-full"
            }`}
            onClick={() => {
              handleOnChangeStage(1);
            }}
          >
            {2}
          </span>
          <div
            className={`w-[220px] lg:w-[800px] flex flex-col justify-center ${
              stage === 1 ? "text-xl font-bold text-[#0f2471]" : ""
            }`}
          >
            <span className={`${stage === 1 ? "mb-4" : ""}`}>
              {t("policy.payment.method2_content.step2.title")}
            </span>

            {stage === 1 && (
              <span className="whitespace-normal text-justify text-base font-bold text-black">
                {t("policy.payment.method2_content.step2.content")}
              </span>
            )}
          </div>
        </div>
        <div className="mb-4 flex items-center">
          <span
            className={`w-[40px] mr-10 flex justify-center items-center cursor-pointer ${
              stage === 2
                ? "w-8 h-10 rounded-full text-white bg-[#0f2471] shadow-xl"
                : "w-8 h-10 border-2 border-[#0f2471] text-[#0f2471] rounded-full"
            }`}
            onClick={() => {
              handleOnChangeStage(2);
            }}
          >
            {3}
          </span>
          <div
            className={`w-[220px] lg:w-[800px] flex flex-col justify-center ${
              stage === 2 ? "text-xl font-bold text-[#0f2471]" : ""
            }`}
          >
            <span className={`${stage === 2 ? "mb-4" : ""}`}>
              {t("policy.payment.method2_content.step3.title")}
            </span>

            {stage === 2 && (
              <span className="whitespace-normal text-justify text-base font-bold text-black">
                {t("policy.payment.method2_content.step3.content")}
                <br />
                <br />
                <em>{t("policy.payment.method2_content.step3.note")}</em>
              </span>
            )}
          </div>
        </div>
        <div className="mb-4 flex items-center">
          <span
            className={`w-[40px] mr-10 flex justify-center items-center cursor-pointer ${
              stage === 3
                ? "w-8 h-10 rounded-full text-white bg-[#0f2471] shadow-xl"
                : "w-8 h-10 border-2 border-[#0f2471] text-[#0f2471] rounded-full"
            }`}
            onClick={() => {
              handleOnChangeStage(3);
            }}
          >
            {4}
          </span>
          <div
            className={`w-[220px] lg:w-[800px] flex flex-col justify-center ${
              stage === 3 ? "text-xl font-bold text-[#0f2471]" : ""
            }`}
          >
            <span className={`${stage === 3 ? "mb-4" : ""}`}>
              {t("policy.payment.method2_content.step4.title")}
            </span>

            {stage === 3 && (
              <span className="whitespace-normal text-justify text-base font-bold text-black">
                {t("policy.payment.method2_content.step4.content")}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayWithBankCard;
